import Vue from 'vue';
import { Tenant } from './tenant.interface';
export const TenantObservable = Vue.observable<Tenant>({
  name: 'VeDicium Passport',
  description: 'Universal and Secure access to your application.',
});
